module.exports = __webpack_public_path__ + "static/media/template-hd3.dc8fd0b9.png";